function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './fapiao-request-form.scss';
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'researcher/components/Loading';
import { Controls, useFormHelpers, validators } from 'shared/helper/form';
import { T, useTranslate } from 'shared/helper/translate';
import { convertFormDataToFapiaoCreationRequest } from 'shared/view/fapiao-conversion-service';
import { defaultValues as addressState } from 'researcher/payment/components/AddressForm';
import { findFapiaoOrganizations } from 'researcher/fapiao/actions';
import FapiaoRequestFormWrapper from './FapiaoRequestFormWrapper';
import FapiaoTypeOption from './FapiaoTypeOption';
var Form = Controls.Form,
  Radio = Controls.Radio,
  Select = Controls.Select,
  Text = Controls.Text,
  AsyncSelect = Controls.AsyncSelect;
var isEmail = validators.isEmail,
  notEmpty = validators.notEmpty,
  createMaximumLengthValidator = validators.createMaximumLengthValidator,
  createRegularExpressionValidator = validators.createRegularExpressionValidator;
var optional = function optional(value) {
  return value === '';
};
var validTaxpayerNumber = createRegularExpressionValidator(/^[0-9A-Z]{6,20}$/);
var optionalTaxpayerNumber = function optionalTaxpayerNumber(value) {
  return optional(value) || validTaxpayerNumber(value);
};
var validOrganizationRegex = createRegularExpressionValidator(/^[^A-Za-z]+$/);
var validOrganizationMaxLength = createMaximumLengthValidator(100);
var validPhoneNumberMaxLength = createMaximumLengthValidator(15);
var validOrganization = function validOrganization(value) {
  return validOrganizationMaxLength(value) && validOrganizationRegex(value);
};
var styles = {
  wrapper: 'mb-3'
};
var defaultValues = {
  contactEmail: '',
  contactPhone: '',
  organizationName: '',
  serviceType: {
    value: null
  },
  taxpayerNumber: '',
  type: '',
  shippingAddress: addressState
};
var FapiaoRequestForm = function FapiaoRequestForm(_ref) {
  var _ref$onFapiaoCreated = _ref.onFapiaoCreated,
    onFapiaoCreated = _ref$onFapiaoCreated === void 0 ? function () {} : _ref$onFapiaoCreated,
    payment = _ref.payment,
    receiptCode = _ref.receiptCode,
    createFapiao = _ref.createFapiao,
    loadFapiaos = _ref.loadFapiaos;
  var dispatch = useDispatch();
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    busy = _useState2[0],
    setBusy = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    previousFapiaoSelections = _useState4[0],
    setPreviousFapiaoSelections = _useState4[1];
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var _useFormHelpers = useFormHelpers(methods),
    preprocessData = _useFormHelpers.preprocessData,
    populateFormData = _useFormHelpers.populateFormData,
    mergeFormData = _useFormHelpers.mergeFormData;
  var currency = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user.currency;
  });
  var fapiaoTypes = useSelector(function (_ref3) {
    var payment = _ref3.payment;
    return payment.fapiaoTypes;
  });
  var organizations = useSelector(function (_ref4) {
    var fapiao = _ref4.fapiao;
    return fapiao === null || fapiao === void 0 ? void 0 : fapiao.organizations;
  });
  var _methods$watch = methods.watch(['type', 'previousFapiaoSelection', 'organizationName']),
    _methods$watch2 = _slicedToArray(_methods$watch, 3),
    type = _methods$watch2[0],
    previousFapiaoSelection = _methods$watch2[1],
    organizationName = _methods$watch2[2];
  var specialFapiao = type === 'special';
  useEffect(function () {
    loadFapiaos().then(function (fapiaos) {
      return setPreviousFapiaoSelections(fapiaos);
    });
  }, []);
  useEffect(function () {
    if (!(previousFapiaoSelection !== null && previousFapiaoSelection !== void 0 && previousFapiaoSelection.value)) {
      return;
    }
    populateFormData(_objectSpread(_objectSpread({}, previousFapiaoSelection), {}, {
      previousFapiaoSelection: previousFapiaoSelection
    }));
  }, [previousFapiaoSelection === null || previousFapiaoSelection === void 0 ? void 0 : previousFapiaoSelection.value]);
  useEffect(function () {
    if (organizationName !== null && organizationName !== void 0 && organizationName.value && !organizationName.newSelection) {
      var organization = organizations === null || organizations === void 0 ? void 0 : organizations.find(function (organization) {
        return organization.organizationName.value === organizationName.value;
      });
      if (organization) {
        mergeFormData({
          taxpayerNumber: organization.taxpayerNumber
        });
      }
    }
  }, [organizationName === null || organizationName === void 0 ? void 0 : organizationName.value]);
  var handleCreateFapiao = function handleCreateFapiao(fapiaoCreationRequest) {
    setBusy(true);
    createFapiao(fapiaoCreationRequest).then(function (fapiaoCreationRequest) {
      setBusy(false);
      if (!fapiaoCreationRequest.error) {
        onFapiaoCreated(fapiaoCreationRequest);
      }
    });
  };
  if (!payment) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }
  return /*#__PURE__*/React.createElement(FapiaoRequestFormWrapper, {
    currency: currency,
    amount: payment.amount
  }, /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    onSubmit: preprocessData(convertFormDataToFapiaoCreationRequest, handleCreateFapiao, {
      paymentId: payment.paymentId,
      receiptCode: receiptCode
    })
  }, /*#__PURE__*/React.createElement(Radio, {
    label: "Type of fapiao",
    messages: {
      notEmpty: 'You must select a fapiao type'
    },
    name: "type",
    validators: {
      notEmpty: notEmpty
    },
    options: [{
      label: t('fapiao-type-general'),
      value: 'general'
    }, {
      label: t('fapiao-type-special'),
      value: 'special'
    }],
    styles: styles
  }), previousFapiaoSelections.length > 0 ? /*#__PURE__*/React.createElement(Select, {
    label: "Use previous Fapiao details",
    options: previousFapiaoSelections.map(function (previousFapiaoSelection) {
      return _objectSpread(_objectSpread({}, previousFapiaoSelection), {}, {
        label: t('previous-fapiao-selection-label', {
          fapiaoType: t("fapiao-type-".concat(previousFapiaoSelection.type)),
          serviceType: t(previousFapiaoSelection.serviceTypeName)
        })
      });
    }),
    name: "previousFapiaoSelection",
    styles: styles,
    description: "This will automatically fill in the details of a previous Fapiao."
  }) : null, /*#__PURE__*/React.createElement(Select, {
    label: "Type of service/product",
    messages: {
      notEmpty: "Value is required and can't be empty"
    },
    name: "serviceType",
    validators: {
      notEmpty: notEmpty
    },
    options: fapiaoTypes.map(function (fapiaoType) {
      return {
        hasParent: fapiaoType.hasParent,
        label: fapiaoType.name,
        value: fapiaoType.id
      };
    }),
    optionComponent: FapiaoTypeOption,
    styles: styles
  }), /*#__PURE__*/React.createElement(AsyncSelect, {
    allowsNewSelection: true,
    label: "Organization name",
    messages: {
      validOrganization: 'fapiao-organization-name-error'
    },
    name: "organizationName",
    validators: {
      validOrganization: validOrganization
    },
    description: "This will appear on your Fapiao.",
    styles: styles,
    isClearable: true,
    minLength: 2,
    maxLength: 100,
    asyncCallback: function asyncCallback(name) {
      return dispatch(findFapiaoOrganizations({
        name: name
      }));
    },
    noOptionsMessage: "Search for your organization"
  }), specialFapiao ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    label: "Taxpayer number",
    messages: {
      validTaxpayerNumber: 'fapiao-taxpayer-number-error'
    },
    name: "taxpayerNumber",
    validators: {
      validTaxpayerNumber: validTaxpayerNumber
    },
    description: "This will appear on your Fapiao.",
    styles: styles
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    label: "Taxpayer number (optional)",
    name: "taxpayerNumber",
    required: false,
    validators: {
      optionalTaxpayerNumber: optionalTaxpayerNumber
    },
    messages: {
      optionalTaxpayerNumber: 'fapiao-taxpayer-number-error'
    },
    description: "This will appear on your Fapiao.",
    styles: {
      wrapper: 'mb-3'
    }
  })), /*#__PURE__*/React.createElement(Text, {
    label: "Email address",
    name: "contactEmail",
    description: "Your e-Fapiao will be sent to this email address.",
    validators: {
      isEmail: isEmail
    },
    messages: {
      isEmail: 'emailAddressInvalidFormat'
    },
    styles: styles
  }), specialFapiao ? /*#__PURE__*/React.createElement(Text, {
    label: "Mobile number",
    maxLength: 15,
    messages: {
      notEmpty: "Value is required and can't be empty",
      validPhoneNumberMaxLength: 'phone-number-too-long'
    },
    name: "contactPhone",
    styles: styles,
    validators: {
      notEmpty: notEmpty,
      validPhoneNumberMaxLength: validPhoneNumberMaxLength
    }
  }) : /*#__PURE__*/React.createElement(Text, {
    label: "Mobile number (optional)",
    maxLength: 15,
    messages: {
      validPhoneNumberMaxLength: 'phone-number-too-long'
    },
    name: "contactPhone",
    styles: {
      wrapper: 'mb-3 optional'
    },
    validators: {
      validPhoneNumberMaxLength: validPhoneNumberMaxLength
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-primary",
    disabled: busy,
    "aria-label": t('Create Fapiao')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Create Fapiao"
  })), busy ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null));
};
export default FapiaoRequestForm;